module.exports = __webpack_public_path__ + "static/media/fontsize.40cff0a1.svg";